// Enum-like object for user roles in the application
export enum Roles {
  GLOBAL = 'GLOBAL_USER', // User with global access
  USER = 'SITE_USER', // Regular user role
  UNKNOWN = '', // Unknown or unset role
}

export enum RolesEnv {
  PROD = 'prod', // Production environment
  TEST = 'test', // Test environment
}

export enum PlantsEnum {
  BRB = 'Brunsbuttel',
  RSK = 'Rostock',
  GLO = 'Glomfjord',
}

export const PlantsOptions = Object.entries(PlantsEnum).map(([key, value]) => ({
  icon: 'FarmIndustrial',
  value: key,
  text: value,
}));
